import React from 'react';
import { Marker } from 'react-map-gl';
import { Button } from '@chakra-ui/react';
import { getLatestObservation, getObservationInPreferredUnits, getParameterUnit } from '../../utils/helpers';
import { UNIT_MAPPINGS, OLD_DATA_THRESHOLD, TIDE_PARAMETER } from '../../utils/constants';
import { CardinalDirectionIndicator } from '../../components/CardinalDirectionIndicator';
import { Flex } from "@chakra-ui/react"
import Observation from '../../components/stations/Observation';

const StationMarkerComponent = (props) => {
  const {
    station,
    isSelected,
    onClick,
    selectedParameter,
    datasetsMetadata,
    showValue,
    preferredUnitSystem,
    currentTab,
  } = props;

  const stationMetadata = datasetsMetadata?.find((dataset) => dataset?.datasetID === station?.datasetID)?.metadata;
  const recentObservations = getLatestObservation(station.obsData, selectedParameter);
  const unit = getParameterUnit(stationMetadata, selectedParameter);
  const observation = getObservationInPreferredUnits(selectedParameter, recentObservations?.[selectedParameter], unit, preferredUnitSystem);

  if (!observation?.value && !isSelected && selectedParameter) {
    return null;
  }

  // TODO: move old data amount of time to consts
  const latestObsDate = selectedParameter === TIDE_PARAMETER
    ? new Date(station.obsData[station.obsData.length - 1].time)
    : new Date(recentObservations?.time);
  const now = new Date();
  const oldData = now - latestObsDate > OLD_DATA_THRESHOLD;

  const borderColor = () => {
    if (isSelected) {
      if (oldData) {
        return 'white';
      } else {
        return 'teal.aoos';
      }
    }

    if (!observation?.value && selectedParameter) {
      return 'gray.200';
    }

    return 'teal.aoos';
  };

  // TODO: get rid of this since we're not even showing by the same logic
  const opacity = () => {
    if (!observation?.value && !isSelected && selectedParameter) {
      return 0.6;
    }

    return 1;
  };
    
  // Checks if a station's selected parameter unit is degrees
  const isDegrees = getParameterUnit(stationMetadata, selectedParameter) === UNIT_MAPPINGS.degrees;

  // Checks if the parameters tab is selected
  const isParametersTab = currentTab === 'parameters';

  return (
    <Marker
      longitude={station.obsData[0].longitude}
      latitude={station.obsData[0].latitude}
      style={{ position: 'absolute', zIndex: 10 }}
    >
      <Button
        color='black'
        className="marker-button"
        display='flex'
        alignItems='center'
        justifyContent='center'
        bg={isSelected ? 'teal.aoos' : 'white'}
        w='40px'
        h='40px'
        p={0}
        fontSize={11}
        borderRadius="50%"
        borderWidth={3}
        borderStyle={oldData ? 'dashed' : 'solid'}
        borderColor={borderColor}
        onClick={() => onClick(station)}
        opacity={opacity}
        _active={{
          bg: isSelected ? 'teal.aoos' : 'white'
        }}
        _focus={{
          bg: isSelected ? 'teal.aoos' : 'white'
        }}
        _hover={{
          bg: isSelected ? 'teal.aoos' : 'white'
        }}
      >
        <Flex direction={'column'} color={isSelected ? 'white' : 'gray.700'}>
          {observation?.value && !isDegrees &&
            <Observation value={observation.value} showUnit={false} />
          }
          {/* Render an arrow if the station has a directional parameter and if the parameters tab is selected */}
          {isDegrees && isParametersTab &&
            <CardinalDirectionIndicator degrees={observation?.value} directionSize={10} arrowSize={15} isMapView />
          }
        </Flex>
      </Button>
    </Marker>
  );
};

const StationMarker = React.memo(StationMarkerComponent);
export default StationMarker;
